module.exports = __webpack_public_path__ + "static/CHD-dd729829748bc6621be6fc31ef51a846.png";